var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendingWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27388 6.47563L7.04544 9.57785L10.1477 15.3494C10.246 15.5298 10.433 15.6445 10.6395 15.6445H10.6789C10.8986 15.6281 11.0855 15.4871 11.1642 15.2805L16.48 0.854916C16.5554 0.651599 16.5062 0.422048 16.3521 0.267922C16.198 0.113795 15.9684 0.0646051 15.7651 0.140029L1.34602 5.45905C1.13943 5.53447 0.998415 5.72467 0.982019 5.94438C0.965622 6.1641 1.0804 6.37069 1.27388 6.47563ZM10.5417 13.7294L8.14453 9.26625L14.5556 2.85522L10.5417 13.7294ZM7.35697 8.476L13.7647 2.06498L2.89057 6.07884L7.35697 8.476Z",
    fill: "#7D7C7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendingWhite);
export default __webpack_public_path__ + "static/media/SendingWhite.0bd29807.svg";
export { ForwardRef as ReactComponent };